import * as S from './SideSectionSummarySegment.styles';

interface SummarySegmentProps {
  children?: React.ReactNode;
}

const SideSectionSummarySegment = ({ children }: SummarySegmentProps) => {
  return <S.Root elevation={2}>{children && children}</S.Root>;
};

export default SideSectionSummarySegment;
